module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00034.c3594ad7.jpg";